import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { SketchPicker } from 'react-color';

type ColorPickerFieldProps = {
  label: string;
  value: string;
  onChange: (hex: string) => void;
  readonly?: boolean;
  defaultColor?: string;
};

const ColorPickerField = ({
  label,
  value,
  onChange,
  readonly = false,
  defaultColor = '#1A2543',
}: ColorPickerFieldProps) => {
  const [open, setOpen] = useState(false);
  const displayColor = value || defaultColor;

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 2 }}>
        <Box
          onClick={() => !readonly && setOpen(true)}
          sx={{
            width: 30,
            height: 30,
            bgcolor: displayColor,
            borderRadius: '50%',
            cursor: readonly ? 'default' : 'pointer',
            border: '1px solid #ccc',
            flexShrink: 0,
          }}
        />
        <Typography variant="subtitle1">{label}</Typography>
        <TextField
          size="small"
          value={value || ''}
          disabled={readonly}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#RRGGBB"
          sx={{ width: 120 }}
        />
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{label}</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
          <SketchPicker
            color={displayColor}
            onChangeComplete={(color) => {
              onChange(color.hex);
              setOpen(false);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Typography
            component="button"
            type="button"
            onClick={() => setOpen(false)}
            sx={{
              border: 0,
              background: 'none',
              cursor: 'pointer',
              color: 'primary.main',
              p: 2,
            }}
          >
            Bezárás
          </Typography>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ColorPickerField;
